import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Box,
  Modal,
  Alert,
  Snackbar,
} from "@mui/material";
import { BUTTON_LABEL, FEEDBACK } from "../../constants/labels";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const Feedback = () => {
  const [feedbackText, setFeedbackText] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleSubmit = () => {
    setOpenModal(true);
    setSnackbarOpen(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setFeedbackText("");
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
      <Card sx={{ maxWidth: 500, width: "100%" ,paddingBottom:"12px"}}>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold", }}>
            {FEEDBACK.TEXT}
          </Typography>
          <TextField
            label="Your Feedback"
            multiline
            rows={6}
            variant="outlined"
            fullWidth
            value={feedbackText}
            onChange={(e) => setFeedbackText(e.target.value)}
            sx={{ mb: 2 }}
          />
          <Button 
            variant="contained"
            onClick={handleSubmit} 
            disabled={!feedbackText?.trim()}
            sx={{float:"right", }}
          >
            {BUTTON_LABEL.SUBMIT}
          </Button>
        </CardContent>
      </Card>

      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="feedback-submission-title"
        aria-describedby="feedback-submission-description"
      >
        <Box sx={modalStyle}>
          <Typography id="feedback-submission-title" variant="h6" component="h2">
            {FEEDBACK.SUBMITTED}
          </Typography>
          <Typography id="feedback-submission-description" sx={{ mt: 2 }}>
            {FEEDBACK.SUBMITTED_MSG}
          </Typography>
          <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
            <Button 
              variant="outlined"
              onClick={handleCloseModal}
            >
              {BUTTON_LABEL.CLOSE}
            </Button>
          </Box>
        </Box>
      </Modal>

      <Snackbar
        anchorOrigin={{vertical: "top", horizontal: "right"}} sx={{mt:8}} 
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity="success" 
          variant="filled"
          className="success-alert"
        >
          {FEEDBACK.SUCCESS_MSG}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Feedback;
